module.exports = __webpack_public_path__ + "static/media/cocon24.62a9a14c.jpg";